import { AppearanceService } from '../services/appearanceService.js';
/**
 * Module Phím khẩn cấp (Boss Key) - Ẩn truyện tức thì khi sếp tới
 */
export class BossKeyModule {
  constructor(spreadsheet, storyReader) {
    this.spreadsheet = spreadsheet;
    this.storyReader = storyReader;
    this.isActive = false;
    this.savedCellData = null;

    this.btnBossKey = document.getElementById('btn-boss-key');
    this.docTitleInput = document.getElementById('doc-title-input');
    this.currentStoryBadge = document.getElementById('current-story-badge');

    this.bindEvents();
  }

  bindEvents() {
    this.btnBossKey.addEventListener('click', () => this.toggle());

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        // 1. Kiểm tra đóng Modal tra cứu truyện
        const modal = document.getElementById('search-modal');
        if (modal && modal.style.display === 'flex') {
          modal.style.display = 'none';
          return;
        }

        // 2. Kiểm tra đóng Modal chọn giao diện
        const themeModal = document.getElementById('theme-selector-modal');
        if (themeModal && themeModal.style.display === 'flex') {
          themeModal.style.display = 'none';
          return;
        }

        // 3. Nếu đang phóng to Fullscreen video (CapCut / Canva): Chỉ thu nhỏ lại, KHÔNG kích hoạt Boss Key
        const isFsActive = !!(document.fullscreenElement || document.webkitFullscreenElement || document.querySelector('.fullscreen-active'));
        if (isFsActive) {
          if (document.fullscreenElement) {
            document.exitFullscreen?.().catch(() => {});
          } else if (document.webkitFullscreenElement) {
            document.webkitExitFullscreen?.().catch(() => {});
          }
          document.querySelectorAll('.fullscreen-active').forEach(el => el.classList.remove('fullscreen-active'));
          window.dispatchEvent(new CustomEvent('video-fullscreen-exited'));
          return;
        }

        // 4. Nếu không ở trạng thái nào trên: Kích hoạt ngụy trang Boss Key
        this.toggle();
      }
    });
  }

  toggle() {
    // Nếu đang ở chế độ Video (CapCut hoặc Canva): Ngắt tiếng, pause ngay lập tức và đưa về Sheets
    if (window.videoPlayerEngine) {
      window.videoPlayerEngine.emergencyMuteAndPause();
    }
    if (window.appRouter && window.appRouter.currentMode === 'video') {
      window.appRouter.showStoryMode('sheets');
    }

    this.isActive = !this.isActive;
    const currentTheme = localStorage.getItem('fake_disguise_theme') || 'sheets';

    if (this.isActive) {
      // Lưu lại dữ liệu truyện
      this.savedCellData = new Map(this.spreadsheet.cellData);

      // Điền bảng số liệu tài chính giả lập
      this.spreadsheet.clear();
      this.docTitleInput.value = 'Báo_cáo_tài_chính_kiểm_toán_2026.xlsx';
      this.currentStoryBadge.textContent = 'Financial Audit Q3';

      for (let r = 1; r <= 60; r++) {
        this.spreadsheet.setCellValue(r, 'A', `Chỉ tiêu tài chính mục ${r}: Khấu hao tài sản cố định & Chi phí vận hành`);
        this.spreadsheet.setCellValue(r, 'C', 'Đã thẩm định');
        this.spreadsheet.setCellValue(r, 'D', 'P. Kế toán');
        this.spreadsheet.setCellValue(r, 'E', (r * 45000000 + 120000000).toLocaleString('vi-VN'));
        this.spreadsheet.setCellValue(r, 'F', (r * 32000000 + 80000000).toLocaleString('vi-VN'));
        this.spreadsheet.setCellValue(r, 'G', (r * 13000000 + 40000000).toLocaleString('vi-VN'));
      }

      this.spreadsheet.renderGrid();
      this.spreadsheet.selectCell(1, 'A');
      AppearanceService.updateAppearance(currentTheme, null, true);
    } else {
      // Khôi phục truyện đang đọc
      if (this.savedCellData) {
        this.spreadsheet.clear();
        this.savedCellData.forEach((val, key) => this.spreadsheet.cellData.set(key, val));

        const story = this.storyReader.currentStory;
        this.docTitleInput.value = `${story.truyenTitle} - ${story.chapterTitle}.xlsx`;
        this.currentStoryBadge.textContent = `${story.truyenTitle} (${story.chapterTitle})`;

        this.spreadsheet.renderGrid();
        this.spreadsheet.selectCell(1, 'A');
        AppearanceService.updateAppearance(currentTheme, this.storyReader?.currentStory, false);
      }
    }
  }
}
